export default "__VITE_ASSET__C2z9ZOyC__"